import { IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { chevronForwardOutline, heart } from 'ionicons/icons';
import { ContentInfo, ContentInterface } from '../data/item';
import React, { Component }  from 'react';

import { LANGUAGE, GetStr } from "../language/Language";
import '../pages/Main.css'; 

  
const EmptyContent : React.FC<ContentInterface> = ({ content }) => {
    
    const router = useIonRouter();

    return (
        <div className="empty-content">
            <div><IonImg className="info-pic" src="/assets/img/empty_pic.png" /></div>
            <div className="ion-margin">{ GetStr(LANGUAGE.TXT_MAIN_NO_CONTENT) }</div>
            <div><IonButton className="ion-margin main-but" routerLink="/explore">{ GetStr(LANGUAGE.TXT_MAIN_NO_CONTENT_BUT) }</IonButton></div>
        </div>
    );
};
  
export default EmptyContent;